<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4.2h4.4c1 0 1.6.6 1.6 1.6v10c0-1-.6-1.6-1.6-1.6H4zM16 4.2h-4.4c-1 0-1.6.6-1.6 1.6v10c0-1 .6-1.6 1.6-1.6H16z"/></svg>
</template>
